/**
 * EMPTY-STATE-DEMONSTRATION-1 — five-pattern empty-state component.
 * pattern prop selects one of: first-use | no-results | all-clear | permission-denied | error-unavailable
 * surface prop: 'operator' (default) | 'customer' — R6 customer-surface override modulates tone.
 */
import { Inbox, SearchX, CheckCircle2, Lock, AlertTriangle } from 'lucide-react';
import './EmptyState.css';

const PATTERN_ICONS = {
  'first-use':          Inbox,
  'no-results':         SearchX,
  'all-clear':          CheckCircle2,
  'permission-denied':  Lock,
  'error-unavailable':  AlertTriangle,
};

export function EmptyState({
  pattern,
  headline,
  body,
  primaryCta,
  secondaryCta,
  surface = 'operator',
}) {
  const Icon = PATTERN_ICONS[pattern];

  return (
    <div
      className={`empty-state empty-state--${pattern} empty-state--surface-${surface}`}
      role="status"
      aria-live="polite"
    >
      {Icon && <Icon className="empty-state__icon" size={40} aria-hidden="true" />}
      <h3 className="empty-state__headline">{headline}</h3>
      {body && <p className="empty-state__body">{body}</p>}
      <div className="empty-state__actions">
        {primaryCta && (
          <button
            type="button"
            onClick={primaryCta.onClick}
            className="empty-state__cta empty-state__cta--primary"
          >
            {primaryCta.label}
          </button>
        )}
        {secondaryCta && (
          <button
            type="button"
            onClick={secondaryCta.onClick}
            className="empty-state__cta empty-state__cta--secondary"
          >
            {secondaryCta.label}
          </button>
        )}
      </div>
    </div>
  );
}
